import { Component, ElementRef, EventEmitter, Injectable, Input, Output, ViewChild } from '@angular/core';
import { Sender } from '../utils/sender.js';
import { InputRemoting } from '../utils/input-remoting.js';
import { Observer } from '../utils/observer.js';
import { Logger } from '../utils/logger.js';
import { NgClass, NgIf } from '@angular/common';

declare const document: any;
declare const navigator: any;
@Component({
  selector: 'app-videoplayer',
  imports: [
    NgIf,
    NgClass
  ],
  templateUrl: './videoplayer.component.html',
  styleUrl: './videoplayer.component.scss',
  standalone: true
})
export class VideoplayerComponent {


  private lockMouseCheck: HTMLInputElement | null = null;
  private inputRemoting: InputRemoting | null = null;
  private sender: Sender | null = null;
  private inputSenderChannel: RTCDataChannel | null = null;
  private onOpenDataChannelCallback: null | ((channel: RTCDataChannel) => void) = null;

  // TODO: it's needed?
  ondisconnect!: (connectionId: any) => Promise<void>;
  videoSrc: MediaStream | null = null;
  fullscreenButtonSrc!: string;
  showVideo: boolean = false;

  @Output() onFullscreenChange: EventEmitter<any> = new EventEmitter();
  @Input('showvideocontrols') showVideoControls: boolean = false;

  @ViewChild('videoElement') videoElement!: ElementRef;
  showFullScreenButton: boolean = false;
  resizeObserver!: ResizeObserver;


  constructor() { }

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === this.videoElement?.nativeElement) {
          console.log('Video resized:', entry.contentRect);
          this.resizeVideo(); // chiama il tuo metodo di gestione del resize
        }
      }
    });

    this.resizeObserver.observe(this.videoElement?.nativeElement);

    this.videoElement?.nativeElement.addEventListener('resize', this.resizeVideo.bind(this));
  }

  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    this.videoElement?.nativeElement.removeEventListener('resize', this.resizeVideo.bind(this));
    
  }

  getVideoElement(): HTMLVideoElement | null {
    return this.videoElement?.nativeElement;
  }

  createPlayer(playerElement: HTMLElement, lockMouseCheck: HTMLInputElement | null): void {
    this.showFullScreenButton = true;
    this.showVideo = true;
    this.lockMouseCheck = lockMouseCheck;
    if (!this.videoSrc)
      this.videoSrc = new MediaStream();
    if (this.videoElement)
      this.videoElement.nativeElement.srcObject = this.videoSrc;
    this.fullscreenButtonSrc = '../images/FullScreen.png'
    document.removeEventListener('webkitfullscreenchange', this._onFullscreenChange.bind(this));
    document.removeEventListener('fullscreenchange', this._onFullscreenChange.bind(this));
    document.addEventListener('webkitfullscreenchange', this._onFullscreenChange.bind(this));
    document.addEventListener('fullscreenchange', this._onFullscreenChange.bind(this));
  }

  public _onLoadedVideo(): void {
    if (this.videoElement) {
      this.videoElement.nativeElement.play();
      setTimeout(() => {
        this.resizeVideo();
      }, 300);

    }
  }

  public _onClickFullscreenButton(): void {
    if (!document.fullscreenElement || !document.webkitFullscreenElement) {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        // document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        document.documentElement.webkitRequestFullscreen();
      } else {
        this.onFullscreenChange.emit(true);
      }
    }
  }

  private _onFullscreenChange(): void {
    if (document.webkitFullscreenElement || document.fullscreenElement) {
      this.onFullscreenChange.emit(true);
      // if (this.playerElement) 
      //   this.playerElement.style.position = "absolute";
      this.showFullScreenButton = false;

      if (this.lockMouseCheck?.checked) {
        const fullscreenElement = document.webkitFullscreenElement || document.fullscreenElement || document.mozFullScreenElement;
        if (fullscreenElement?.requestPointerLock) {
          fullscreenElement.requestPointerLock();
        }

        document.addEventListener('mousemove', this._mouseMove.bind(this), false);
        document.addEventListener('click', this._mouseClickFullScreen.bind(this), false);
      }
    } else {
      this.onFullscreenChange.emit(false);
      this.showFullScreenButton = true;
      // if (this.playerElement) this.playerElement.style.position = "relative";
      // if (this.fullScreenButtonElement) this.fullScreenButtonElement.style.display = 'block';

      document.removeEventListener('mousemove', this._mouseMove.bind(this), false);
      document.removeEventListener('click', this._mouseClickFullScreen.bind(this), false);
    }
  }

  private _mouseMove(event: MouseEvent): void {
    if (this.sender) {
      this.sender._onMouseEvent(event);
    }
  }

  public _mouseClick(): void {
    if (this.lockMouseCheck?.checked && this.videoElement?.nativeElement.requestPointerLock) {
      //   this.videoElement.requestPointerLock().catch(() => {});
      this.videoElement.nativeElement.requestPointerLock();
    }
  }

  private _mouseClickFullScreen(): void {
    if (this.lockMouseCheck?.checked) {
      const fullscreenElement = document.webkitFullscreenElement || document.fullscreenElement || document.mozFullScreenElement;
      if (fullscreenElement?.requestPointerLock) {
        fullscreenElement.requestPointerLock();
      }
    }
  }

  addTrack(track: MediaStreamTrack): void {
    this.videoSrc?.addTrack(track);
  }

  setVideoMediaStream(mediaStream: MediaStream): void {
    this.videoSrc = mediaStream;
    if (this.videoElement)
      this.videoElement.nativeElement.srcObject = this.videoSrc;
  }

  resizeVideo(): void {
    if (!this.videoElement) {
      return;
    }
    setTimeout(() => {
      Logger.log('resize video');
      const clientRect = this.videoElement.nativeElement.getBoundingClientRect();
      const videoRatio = this.videoWidth / this.videoHeight;
      const clientRatio = clientRect.width / clientRect.height;

      const videoScale = videoRatio > clientRatio ? clientRect.width / this.videoWidth : clientRect.height / this.videoHeight;
      const videoOffsetX = videoRatio > clientRatio ? 0 : (clientRect.width - this.videoWidth * videoScale) * 0.5;
      const videoOffsetY = videoRatio > clientRatio ? (clientRect.height - this.videoHeight * videoScale) * 0.5 : 0;

      this._videoScale = videoScale;
      this._videoOriginX = clientRect.left + videoOffsetX;
      this._videoOriginY = clientRect.top + videoOffsetY;
    }, 5)

  }

  get videoWidth(): number {
    return this.videoElement ? this.videoElement.nativeElement.videoWidth : 0;
  }

  get videoHeight(): number {
    return this.videoElement ? this.videoElement.nativeElement.videoHeight : 0;
  }

  get videoOriginX(): number {
    return this._videoOriginX || 0;
  }

  get videoOriginY(): number {
    return this._videoOriginY || 0;
  }

  get videoScale(): number {
    return this._videoScale || 1;
  }

  deletePlayer(): void {
    if (this.inputRemoting) {
      this.inputRemoting.stopSending();
    }
    this.inputRemoting = null;
    this.sender = null;
    this.inputSenderChannel = null;

    this.showVideo = false;

    this.lockMouseCheck = null;
  }

  private _isTouchDevice(): boolean {
    return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
  }

  setupInput(channel: RTCDataChannel, callback?: (channel: RTCDataChannel) => void): RTCDataChannel | null {
    if (this.videoElement) {
      this.sender = new Sender(this.videoElement.nativeElement);
      this.sender.addMouse();
      this.sender.addKeyboard();
      if (this._isTouchDevice()) {
        this.sender.addTouchscreen();
      }
      this.sender.addGamepad();
      this.inputRemoting = new InputRemoting(this.sender);

      this.inputSenderChannel = channel;
      if (callback) {
        this.onOpenDataChannelCallback = callback
      }
      this.inputSenderChannel.onopen = this._onOpenInputSenderChannel.bind(this);
      this.inputRemoting.subscribe(new Observer(this.inputSenderChannel));
      return this.inputSenderChannel;
    }
    return null;
  }

  private async _onOpenInputSenderChannel(): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 100));
    this.inputRemoting?.startSending();
    if (this.onOpenDataChannelCallback && this.inputSenderChannel) {
      setTimeout(() => {
        if (this.onOpenDataChannelCallback && this.inputSenderChannel) {
          this.onOpenDataChannelCallback(this.inputSenderChannel);
        }
      }, 200);
    }
  }

  sendMsg(msg: string | ArrayBuffer): boolean {
    if (this.inputSenderChannel) {
      switch (this.inputSenderChannel.readyState) {
        case 'connecting':
          Logger.log('Connection not ready');
          break;
        case 'open':
          Logger.debug('videoplayer - send using data channel - ' + msg);
          if (typeof msg === 'string') {
            this.inputSenderChannel.send(msg);
          } else {
            this.inputSenderChannel.send(msg);
          }
          return true
          break;
        case 'closing':
          Logger.log('Attempt to send message while closing');
          break;
        case 'closed':
          Logger.log('Attempt to send message while connection closed.');
          break;
      }
    }
    return false;
  }

  dateOnScreenshot: boolean = true;

  takeScreenshot() {
    const now = new Date();

    const canvas = document.createElement('canvas');
    const video = this.videoElement.nativeElement;
    const aspectRatio = video.videoWidth / video.videoHeight;
    canvas.width = video.getBoundingClientRect().width;
    // canvas.height = video.getBoundingClientRect().height / aspectRatio;
    canvas.height = canvas.width / aspectRatio;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      if (this.dateOnScreenshot) {
        const timestamp = now.toLocaleString();
        // Configura lo stile per il rettangolo e il testo
        const padding = 10;
        const fontSize = 16;
        ctx.font = `${fontSize}px Arial`;
        ctx.textBaseline = 'top';
        const textWidth = ctx.measureText(timestamp).width;
        const rectWidth = textWidth + padding * 2;
        const rectHeight = fontSize + padding * 2;
        // Posiziona il rettangolo in basso a destra
        const x = canvas.width - rectWidth - 5;
        const y = canvas.height - rectHeight - 5;

        // Disegna il rettangolo bianco
        ctx.fillStyle = 'white';
        ctx.fillRect(x, y, rectWidth, rectHeight);

        // Disegna il testo nero
        ctx.fillStyle = 'black';
        ctx.fillText(timestamp, x + padding, y + padding);
      }

      const dataURL = canvas.toDataURL('image/png');
      return dataURL;
    }
    return null;
  }

  // Private properties for video positioning
  private _videoScale: number = 1;
  private _videoOriginX: number = 0;
  private _videoOriginY: number = 0;
}
